import ResponseStore from "@shared/stores/ResponseStore";

const TenantStore = {
  data: {
    tenant: { logo: {}, theme: {}, meta_title: {}, meta_description: {}, login_signup_text: {}, merchant_vat_mention_text: {}, service_vat_mention_text: {} },
    homepageModules: [],
    countryTenants: []
  },

  methods: {
    // Tenants

    async ensureCurrentTenant (id) {
      if (!TenantStore.data.tenant.id) {
        if (id) {
          TenantStore.methods.assignTenant(await TenantStore.methods.fetchAdminTenant(id));
        } else {
          TenantStore.methods.assignTenant(await TenantStore.methods.fetchCurrentAdminTenant());
        }
      }
    },

    async fetchTenant (id) {
      const response = await fetch(`/api/v4/tenants/${id}`);
      const responseJSON = await response.json();

      return responseJSON.tenant;
    },

    async fetchAdminTenant (id) {
      const response = await fetch(`/api/v4/tenants/${id}/show_admin`);
      const responseJSON = await response.json();

      return responseJSON.tenant;
    },

    async fetchCurrentTenant () {
      const response = await fetch("/api/v4/tenant");
      const responseJSON = await response.json();

      return responseJSON.tenant;
    },

    async fetchCurrentAdminTenant () {
      const response = await fetch("/api/v4/admin_tenant");
      const responseJSON = await response.json();

      return responseJSON.tenant;
    },

    async fetchTenants () {
      const response = await fetch("/api/v4/tenants");
      const responseJSON = await response.json();

      return responseJSON.tenants;
    },

    async fetchTenantNames () {
      const response = await fetch("/api/v4/tenants/tenant_names");
      const responseJSON = await response.json();

      return responseJSON.tenants;
    },

    assignTenant (tenant) {
      TenantStore.data.tenant = tenant;
    },

    nullifyTenant () {
      TenantStore.data.tenant = {};
    },

    async createTenant () {
      let response = await fetch(
        "/api/v4/tenants", {
          body: new FormData(document.getElementById("form-card")),
          method: "POST"
        });

      ResponseStore.finishProcessing();

      return response.json();
    },

    async updateTenant (tenant) {
      let response = await fetch(
        `/api/v4/tenants/${tenant.id}`, {
          body: new FormData(document.getElementById("form-card")),
          method: "PUT"
        });

      ResponseStore.finishProcessing();

      return response.json();
    },

    // Homepage modules

    async fetchHomepageModules () {
      const response = await fetch(`/api/v4/tenants/${TenantStore.data.tenant.id}/homepage_modules`);
      const responseJSON = await response.json();

      return responseJSON.homepage_modules;
    },

    async fetchHomepageModule (homepageModuleId, homepageModuleType) {
      const response = await fetch(`/api/v4/tenants/${TenantStore.data.tenant.id}/homepage_modules/${homepageModuleId}?module_type=${homepageModuleType}`);
      const responseJSON = await response.json();

      return responseJSON.homepage_module;
    },

    // Countries

    async fetchAllCountries () {
      let response = await fetch("/api/v4/countries/all");
      let responseJSON = await response.json();

      return responseJSON.countries;
    },

    async fetchTenantCountries (tenant) {
      let response = await fetch(`/api/v4/tenants/${tenant.id}/countries`);
      let responseJSON = await response.json();

      return responseJSON.countries;
    },

    async fetchTenantHomepageEnabledCountries (tenant) {
      let response = await fetch(`/api/v4/tenants/${tenant.id}/countries/homepage_enabled`);
      let responseJSON = await response.json();

      return responseJSON.countries;
    },

    async fetchCountryCurrencies (countryId) {
      let response = await fetch(`/api/v4/countries/${countryId}/currencies`);
      let responseJSON = await response.json();

      return responseJSON.currencies;
    },

    // Currencies

    async fetchAllCurrencies () {
      let response = await fetch("/api/v4/currencies/all");
      let responseJSON = await response.json();

      return responseJSON.currencies;
    },

    async fetchTenantCurrencies (tenant) {
      let response = await fetch(`/api/v4/tenants/${tenant.id}/currencies`);
      let responseJSON = await response.json();

      return responseJSON.currencies;
    },

    // Country Tenants

    async fetchCountryTenants (tenantId) {
      const response = await fetch(`/api/v4/tenants/${tenantId}/country_tenants`);
      const responseJSON = await response.json();

      return responseJSON.country_tenants;
    },

    async fetchCountryTenant (tenantId, countryTenantId) {
      const response = await fetch(`/api/v4/tenants/${tenantId}/country_tenants/${countryTenantId}`);
      const responseJSON = await response.json();

      return responseJSON.country_tenant;
    },

    async createCountryTenant (tenantId) {
      let response = await fetch(`/api/v4/tenants/${tenantId}/country_tenants`, {
        body: new FormData(document.getElementById("form-card")),
        method: "POST"
      });

      ResponseStore.finishProcessing();

      return response.json();
    },

    async updateCountryTenant (tenant, countryTenant) {
      let response = await fetch(
        `/api/v4/tenants/${tenant.id}/country_tenants/${countryTenant.id}`, {
          body: new FormData(document.getElementById("form-card")),
          method: "PUT"
        });

      ResponseStore.finishProcessing();

      return response.json();
    },

    async destroyCountryTenant (tenantId, countryTenantId) {
      let response =
        await fetch(`/api/v4/tenants/${tenantId}/country_tenants/${countryTenantId}`, {
          method: "DELETE"
        });

      return response.json();
    },

    // Currency Tenants

    async fetchCurrencyTenants (tenantId, countryId = "") {
      const response = await fetch(`/api/v4/tenants/${tenantId}/currency_tenants?country_id=${countryId}`);
      const responseJSON = await response.json();

      return responseJSON.currency_tenants;
    },

    async fetchVisibleCurrencyTenants (tenantId, countryId = "") {
      const response = await fetch(`/api/v4/tenants/${tenantId}/currency_tenants/public?country_id=${countryId}`);
      const responseJSON = await response.json();

      return responseJSON.currency_tenants;
    },

    async fetchCurrencyTenant (tenantId, currencyTenantId) {
      const response = await fetch(`/api/v4/tenants/${tenantId}/currency_tenants/${currencyTenantId}`);
      const responseJSON = await response.json();

      return responseJSON.currency_tenant;
    },

    async fetchPointOfSale (pointOfSaleId) {
      const response = await fetch(`/api/v4/tenants/${TenantStore.data.tenant.id}/points_of_sale/${pointOfSaleId}`);
      const responseJSON = await response.json();

      return responseJSON.point_of_sale;
    },

    async fetchPointsOfSale () {
      let response = await fetch(`/api/v4/tenants/${TenantStore.data.tenant.id}/points_of_sale`);
      let responseJSON = await response.json();

      return responseJSON.points_of_sale;
    },

    async updatePointOfSale (tenantId, pointOfSale) {
      let response = await fetch(
        `/api/v4/tenants/${tenantId}/points_of_sale/${pointOfSale.id}`, {
          body: new FormData(document.getElementById("form-card")),
          method: "PUT"
        });

      ResponseStore.finishProcessing();

      return response.json();
    },

    async fetchPaymentCallbackToken (paymentMethodId) {
      const response = await fetch(`api/v4/payment_methods/${paymentMethodId}/callback_token`);
      const responseJSON = await response.json();

      return responseJSON.callback_token;
    },

    async fetchPaymentMethodBadges () {
      const response = await fetch("api/v4/payment_method_badges");
      const responseJSON = await response.json();

      return responseJSON.payment_method_badges;
    },

    async updatePaymentMethodBadges (badgeId, paymentMethodId) {
      let data = new FormData();
      data.append("payment_method_id", paymentMethodId);

      ResponseStore.finishProcessing();

      let response = await fetch(
        `api/v4/payment_method_badges/${badgeId}`, {
          body: data,
          method: "PATCH"
        }
      );

      return response.json();
    },

    // Fees

    async fetchFees (tenantId) {
      let id;
      if (tenantId) {
        id = tenantId;
      } else {
        id = TenantStore.data.tenant.id;
      }

      const response = await fetch(`/api/v4/tenants/${id}/fees`);
      const responseJSON = await response.json();

      return responseJSON.fees;
    },

    async fetchFee (feeId) {
      const response = await fetch(`/api/v4/tenants/${TenantStore.data.tenant.id}/fees/${feeId}`);
      const responseJSON = await response.json();

      return responseJSON.fee;
    },

    // Payment Plugins

    async fetchPaymentPlugins () {
      const response = await fetch("/api/v4/payment_plugins");
      const responseJSON = await response.json();

      return responseJSON.payment_plugins;
    },

    // Vats

    async fetchVats (tenantId) {
      const response = await fetch(`/api/v4/tenants/${tenantId}/vats`);
      const responseJSON = await response.json();

      return responseJSON.vats;
    },

    async fetchVat (tenantId, vatId) {
      const response = await fetch(`/api/v4/tenants/${tenantId}/vats/${vatId}`);
      const responseJSON = await response.json();

      return responseJSON.vat;
    },

    updateTenantWithTheme (theme) {
      TenantStore.data.tenant.theme = theme;
    },

    updateTenantWithPassbookSetting (setting) {
      TenantStore.data.tenant.passbook_setting = setting;
    },

    async regenerateStylesheets (themeId) {
      let response = await fetch(
        `/api/v4/tenants/${TenantStore.data.tenant.id}/themes/${themeId}/regenerate_stylesheets`, {
          body: new FormData(document.getElementById("form-card")),
          method: "POST"
        });

      ResponseStore.finishProcessing();

      return response.json();
    },

    async updateTheme (theme) {
      let response = await fetch(
        `/api/v4/tenants/${TenantStore.data.tenant.id}/themes/${theme.id}`, {
          body: new FormData(document.getElementById("form-card")),
          method: "PUT"
        });

      ResponseStore.finishProcessing();

      return response.json();
    },

    async createTheme () {
      let response = await fetch(
        `/api/v4/tenants/${TenantStore.data.tenant.id}/themes`, {
          body: new FormData(document.getElementById("form-card")),
          method: "POST"
        });

      ResponseStore.finishProcessing();

      return response.json();
    },

    async destroyTheme (theme) {
      let response = await fetch(
        `/api/v4/tenants/${TenantStore.data.tenant.id}/themes/${theme.id}`, {
          method: "DELETE"
        });

      ResponseStore.finishProcessing();

      return response.json();
    },

    async updatePassbookSetting (setting) {
      let response = await fetch(
        `/api/v4/tenants/${TenantStore.data.tenant.id}/passbook_settings/${setting.id}`, {
          body: new FormData(document.getElementById("form-card")),
          method: "PUT"
        });

      ResponseStore.finishProcessing();

      return response.json();
    },

    async createPassbookSetting () {
      let response = await fetch(
        `/api/v4/tenants/${TenantStore.data.tenant.id}/passbook_settings`, {
          body: new FormData(document.getElementById("form-card")),
          method: "POST"
        });

      ResponseStore.finishProcessing();

      return response.json();
    },

    async destroyPassbookSetting (setting) {
      let response = await fetch(
        `/api/v4/tenants/${TenantStore.data.tenant.id}/passbook_settings/${setting.id}`, {
          method: "DELETE"
        });

      ResponseStore.finishProcessing();

      return response.json();
    }

    // generator
  }
};

export default TenantStore;
